/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MatchTestItem } from '../../models/match-test-item';

export interface GetStudentProfileMatchTestItems$Params {
  profileId: string;
}

export function getStudentProfileMatchTestItems(http: HttpClient, rootUrl: string, params: GetStudentProfileMatchTestItems$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MatchTestItem>>> {
  const rb = new RequestBuilder(rootUrl, getStudentProfileMatchTestItems.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MatchTestItem>>;
    })
  );
}

getStudentProfileMatchTestItems.PATH = '/studentprofile/{profileId}/matchtest';
